<template> 
    <div class="schedule">
        <h6 class="title-section">Horario</h6>
        <div class="send-request" id="DivSchedulesOptions" v-if="flagVista">
          <b-container>
            <b-row>
              <b-col v-for="(item, index) in $t('listScheduleOption.list')" v-bind:key="index">
                <div class="shipping">
                  <div class="title">
                    <img :src="getImgUrl(item.image)">
                    <h6>{{item.titleMain}} <br> {{item.title}}</h6>
                  </div>

                  <ol  class="custom-counter">
                      <li class="content-points line-gris" v-for="(itemDetalle, indexDetalle) in item.listSchedulesOptionsFeatures" v-bind:key="indexDetalle">
                          <div class="points arrow-gris">
                              <h6>{{itemDetalle.title}}</h6>
                              <ul v-for="(itemDescription, indexDescription) in itemDetalle.listDescription" v-bind:key="indexDescription">
                                  <li>{{itemDescription.description}}</li>
                              </ul>
                          </div>
                      </li>

               </ol>
                <b-button variant="primary" @click="redirectSchedule(item.id)" :disabled="datosSidebar.flagViewMenuOptions">{{item.btnElegir}}</b-button>
            </div>
              </b-col>
            </b-row>
          </b-container>
        </div>
        <!-- <b-toast id="toast-check-modal-error" variant="none" no-close-button toaster="b-toaster-top-center">
            <img src="@/assets/img/ico-equis.png" style="margin-right: 10px; margin-top: -2px" />
            {{ message }}
        </b-toast> -->
        <b-modal id="toast-check-modal-error" ref="toast-check-modal-error"
          :hide-footer="true" 
          :hide-header="true" 
          :centered="true">
          <img class="close" src="@/assets/img/close_red.png" @click="$bvModal.hide('toast-check-modal-error')">
          <p class="text-center mb-0">{{ message }}</p>
          </b-modal>
    </div>
</template>

<script>
import  obj  from '@/locales/es.json';
import { baseInstanceAxios } from "@/assets/js/axiosBase.js";
import { showSidebar ,redirectHorarioUpdate} from '@/assets/js/util.js';
import * as Constants from "@/assets/js/appConstants";

export default {
	data() {
		return {
			API_URL: process.env.VUE_APP_API_URL,
			schedulesOptions: [],
			tabIndex: 0,
      flagVista:false,
      message: this.$t('horarioIndex.text'),
		}
	},
  props:['student'],
  computed: {
				User: {
						get() {
								return this.$store.state.user;
						},
				},
        is_representative: {
            get() {
              return this.$store.state.is_representative;
            }
        },
        datosSidebar: {
			    get() {
				    return this.$store.state.datosSidebar;
			    }
		    }
	},
	created() {
  
    redirectHorarioUpdate(this.datosSidebar.typeScheduled,this,this.is_representative,this.student);
    showSidebar();
		this.validarAccesoVistaHorarios();
	},
  methods:{
    getSchedulesOptions: function() {
      if(obj.listScheduleOption.list != null && obj.listScheduleOption.list != null){
        this.schedulesOptions = obj.listScheduleOption.list;
      }
    },
    validarAccesoVistaHorarios: function() {
	
			let json = {
				GroupsId: this.User.groupId != null ? this.User.groupId : 0,
				PersonId: this.User.id,
				PersonStudentId: this.User.personStudentId,
				Page: 0,
				Size: 0,
				TypeSearch: false
			};
	
			baseInstanceAxios
				.post(`${this.apiURL}/resources/dashboard/GetDataGeneral`, json)
				.then((response) => {
					
					if(response.data != null){
						if(response.data.entity != null ){
							//SI EL PLAN NO ESTÁ ACTIVO NO DEBERIA DEJAR ENTRAR A HORARIOS
              if(!response.data.entity.flagActivePlan){
                //ESTAS DOS LINEAS DEBEN SER COMENTADAS
                this.flagVista = true;
                this.getSchedulesOptions();

                //this.$router.push({ path: `/compra/0` }).catch(err => {});
              }else{
                this.flagVista = true;
                this.getSchedulesOptions();
              }
						}
					}
				});
		},
    getImgUrl(pic) {
      if(pic != null){
        return require('@/assets/img/'+pic)
      }
      
    },
    redirectSchedule: function(id){
      
      if(this.is_representative){
        let path = "/horario/calendario/public";
        if(id == Constants.SCHEDULES_OPTIONS.SOLICITUD_MASIVA){
          path = "/horario/calendario/public";
        }else if(id == Constants.SCHEDULES_OPTIONS.SOLICITUD_DIRECTA){
          path = "/horario/calendario/private";
        }
        this.$router.push({ path: path})
        //this.$router.push('/horario/calendario/' + id);
      }
      else{
        // this.$bvToast.show("toast-check-modal-error");
        this.$refs['toast-check-modal-error'].show()
      }
    }
  }
}
</script>